import { cartNumber, cartSchedule } from './cartItem';

// Match the API clock even when the device uses a different time zone.
export function cartReferenceDate(schedule: any, now = new Date()): Date | null {
  if (!schedule) return now;
  const day = String(schedule.data || '').match(/^\d{4}-\d{2}-\d{2}/)?.[0];
  const time = String(schedule.hora || '').match(/(?:T|^)(\d{2}:\d{2})/)?.[1];
  if (!day || !time) return null;
  const date = new Date(`${day}T${time}:00-03:00`);
  return Number.isFinite(date.getTime()) ? date : null;
}

export function cartProductAvailable(product: any, schedule = cartSchedule(), now = new Date()): boolean {
  const date = cartReferenceDate(schedule, now);
  if (!product || product.ativo === false || product.internet !== true || !date) return false;
  const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'America/Sao_Paulo',
    year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit',
    hourCycle: 'h23' } as Intl.DateTimeFormatOptions).formatToParts(date);
  const fields: Record<string, string> = {};
  parts.forEach(part => { fields[part.type] = part.value; });
  const day = new Date(`${fields.year}-${fields.month}-${fields.day}T12:00:00Z`).getUTCDay();
  const time = `${fields.hour}:${fields.minute}`;
  const availability = product.disponibilidadeDelivery;
  const days = Array.isArray(availability?.dias) ? availability.dias : [];
  const ranges = Array.isArray(availability?.horarios) ? availability.horarios : [];
  const validDay = (value: number) => !days.length || days.includes(value);
  if (availability && Object.prototype.hasOwnProperty.call(availability, 'horariosPorDia')) {
    const perDay = availability.horariosPorDia;
    const valid = Array.isArray(perDay) && perDay.some((entry: any) => {
      if (!Number.isInteger(entry?.dia) || entry.dia < 0 || entry.dia > 6 || !validDay(entry.dia)) return false;
      return Array.isArray(entry.horarios) && entry.horarios.some((range: any) => {
        if (!/^([01]\d|2[0-3]):[0-5]\d$/.test(range?.inicio) || !/^([01]\d|2[0-3]):[0-5]\d$/.test(range?.fim)) return false;
        return range.inicio > range.fim
          ? (day === entry.dia && time >= range.inicio) || (day === (entry.dia + 1) % 7 && time <= range.fim)
          : day === entry.dia && time >= range.inicio && time <= range.fim;
      });
    });
    return valid && (!product.controlarEstoque || cartNumber(product.quantidadeEstoque) > 0);
  }
  const validTime = ranges.length ? ranges.some((range: any) => {
    if (!/^\d{2}:\d{2}$/.test(range?.inicio) || !/^\d{2}:\d{2}$/.test(range?.fim)) return false;
    const overnight = range.inicio > range.fim;
    const scheduleDay = overnight && time <= range.fim ? (day + 6) % 7 : day;
    return validDay(scheduleDay) && (overnight ? time >= range.inicio || time <= range.fim
      : time >= range.inicio && time <= range.fim);
  }) : validDay(day);
  return validTime && (!product.controlarEstoque || cartNumber(product.quantidadeEstoque) > 0);
}
